import {
  WorksheetBatchUpdateCommonDefaultParams,
  WorksheetBatchUpdateCommonQueryFields,
  WorksheetBatchUpdateCommonRequiredParams,
} from 'Components/WorksheetBatchUpdate/Core/SharedQueryFields';
import { WorksheetBatchUpdateDefinition } from '../..';
import AsNuclearFieldDensityWorksheetFields, {
  AsNuclearFieldDensityWorksheetSections,
} from './AsNuclearFieldDensityWorksheetFields';

const AsNuclearFieldDensityBatchUpdateDefinition: WorksheetBatchUpdateDefinition = {
  worksheetType: 'Nuclear Field Density',
  query: {
    defaultParams: WorksheetBatchUpdateCommonDefaultParams,
    requiredParams: WorksheetBatchUpdateCommonRequiredParams,
  },
  queryFields: WorksheetBatchUpdateCommonQueryFields,
  worksheetFields: AsNuclearFieldDensityWorksheetFields,
  worksheetFieldSections: AsNuclearFieldDensityWorksheetSections,
};

export default AsNuclearFieldDensityBatchUpdateDefinition;

export { AsNuclearFieldDensityBatchUpdateDefinition };
